"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceIssuancePendingEntity = void 0;
class InvoiceIssuancePendingEntity {
    id;
    eventId;
    settlementId;
    campaignGroupId;
    issuerUserId;
    issuerName;
    issuerTaxId;
    commissionName;
    amount;
    currency;
    operationDate;
    status;
    reason;
    attempts;
    invoiceIds;
    nextAttemptAt;
    resolvedAt;
    createdAt;
    updatedAt;
}
exports.InvoiceIssuancePendingEntity = InvoiceIssuancePendingEntity;
